import { TOOLTIP_STATES } from "@infrastructure/Hooks/useTooltipStateHandler";
import React, { useEffect, useState } from "react";
import { ModalReactionsListTooltipContainer } from "../ReactionsList.styles";
import { reactions } from "@infrastructure/Persistence/Reactions";
import { ModalReactionToggleButton } from "../Reaction.styles";
import { GetReactionIcon } from "../ReactionsIconsFactory";
import {
    useUserStore,
    UserLoginActionState,
} from "@infrastructure/Persistence/UserState";
import { ReactionsNamesEnum } from "../../../../Types/Reactions/ReactionsNamesEnum";
import { getUserReactionOnObject } from "@infrastructure/Hooks/UserInteractions/useUserReactions";
import { ReactionableObjectEnum } from "@infrastructure/Hooks/UserInteractions/UserInteractions.types";

export function ModalPostReactionsListTooltip({
    postId,
    reactOnEntity,
    successCallback,
    tooltipStateHandler,
}: {
    postId: string;
    reactOnEntity: (reactionTypeName: string, action: string) => void;
    successCallback?: () => void;
    tooltipStateHandler?: (newState: TOOLTIP_STATES) => void;
}) {
    const [userReactions, setUserReactions] = useState<string[]>([]);
    useEffect(() => {
        const userReaction = getUserReactionOnObject(
            postId,
            ReactionableObjectEnum.POST,
        );
        if (userReaction) {
            setUserReactions([userReaction]);
        }
    }, [postId]);

    const { setUserAuthContextState } = useUserStore();

    const changeSelectedReactions = (
        event: React.MouseEvent<HTMLElement>,
        newFormats: string[],
    ) => {
        setUserReactions(newFormats);
    };
    return (
        <ModalReactionsListTooltipContainer
            value={userReactions}
            onChange={changeSelectedReactions}
            onPointerEnter={() => {
                tooltipStateHandler?.(TOOLTIP_STATES.OPEN);
            }}
            onPointerLeave={() => {
                tooltipStateHandler?.(TOOLTIP_STATES.CLOSE);
            }}
        >
            {reactions.map((reaction, key) => {
                if (
                    reaction.name !== ReactionsNamesEnum.LIKE &&
                    reaction.name !== ReactionsNamesEnum.DISLIKE
                ) {
                    return null;
                }
                const reactionName = reaction.name;
                const active = userReactions.includes(reactionName);
                const onReactionClicked = () => {
                    const action = active ? "delete" : "create";
                    reactOnEntity(reactionName, action);
                };
                return (
                    <ModalReactionToggleButton
                        key={key}
                        onClick={(e) => {
                            e.stopPropagation();
                            e.preventDefault();
                            setUserAuthContextState(
                                UserLoginActionState.CREATE_REACTION,
                            );
                            onReactionClicked();
                            successCallback && successCallback();
                        }}
                        sx={{ borderLeft: "none" }}
                        value={reactionName}
                    >
                        <GetReactionIcon reactionName={reactionName} />
                    </ModalReactionToggleButton>
                );
            })}
        </ModalReactionsListTooltipContainer>
    );
}
